<template>
  <div class="job-placement" id="view">
    <hero-section
      :subTitle="subTitle"
      :title="title"
      imageName="job-placement-hero-2.webp"
      :description="description"
      :showDarkerWave="true"
      :reverseOrder="true"
      :navIndicator="navIndicator"
    />
    <main-container />
    <disclaimer-section />
    <GetStarted-section />
  </div>
</template>

<script>
import HeroSection from '@/components/partials/HeroSection.vue';
import NewMainContainer from './Sections/NewMainContainer.vue';
import DisclaimerSection from './Sections/DisclaimerSection.vue';
import GetStartedSection from './Sections/GetStarted.vue';

export default {
  components: {
    'hero-section': HeroSection,
    'main-container': NewMainContainer,
    'disclaimer-section': DisclaimerSection,
    'GetStarted-section': GetStartedSection,
  },
  data: () => ({
    title: 'Excel with <span style="color: var(--accent-red)">DIGU</span>',
    subTitle: `<span style="color:black; text-transform: capitalize;">DIGU Connects Nepali Professionals<br /> With Global Companies. </span>`,
    description: `We are building a bridge between job providers and job seekers. To be part of our program, candidates must be accepted into our Talent Pool. Our Talent Pool features skilled professionals from Nepal, whose resumes we share with clients in the U.S., Canada, and Australia. If your profile matches their needs, we’ll reach out to you.`,
    UIController: {
      display: {
        hideStaffSteps: false,
        hideDeveloperSteps: true,
      },
    },
    navIndicator: [
      { text: 'Home', icon: 'fas fa-home', link: '/' },
      { text: 'For Job Seekers', link: '#' },
      { text: 'Remote Career Acceleration Program', link: '' },
    ],
  }),
  created() {
    document.getElementById('loaderSection').classList.add('d-none');
  },
};
</script>
